"use client"; // Error components must be Client Components

import { useEffect } from "react";
import { Button } from "@/components/ui/button"; // Assuming you have this

export default function Error({ error, reset }) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error("Root error boundary caught:", error);
  }, [error]);

  return (
    <div style={{ padding: '20px', textAlign: 'center', border: '1px solid var(--sal-status-danger-solid)', margin: '20px' }}>
      <h2>Something went wrong!</h2>
      <p>{error?.message || "An unexpected error occurred."}</p>
      <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all', textAlign: 'left', maxHeight: '300px', overflowY: 'auto', background: 'var(--sal-surface-sunken)', padding: '10px', marginTop: '10px' }}>
        {error?.stack || "No stack trace available."}
      </pre>
      <Button
        onClick={
          // Attempt to recover by trying to re-render the segment
          () => reset()
        }
        variant="destructive"
        className="mt-4"
      >
        Try again
      </Button>
    </div>
  );
} 